import config from './config.api';
import { axiosWithHeaders, Services } from '@innovyze/lib_get_service';

const flowGptApi = axiosWithHeaders({
	// 'w3fAgentServer' is a new service not yet present in the installed
	// @innovyze/lib_get_service Services union; cast until the lib is bumped.
	service: 'w3fAgentServer' as Services,
	config,
	axiosCreateOpts: {
		timeout: 60000,
	},
});

export default flowGptApi;
